<template>
	<div :class="element_class">
		<label :for="id">{{ label }}</label>
		<div class="input-group mb-3">
			<input type="text" class="form-control" v-model="internal_date" :placeholder="placeholder" :id="id">
			<div class="input-group-append input-group-addon">
				<button @click="open" class="btn btn-outline-secondary" type="button"><i :aria-label="placeholder" class="far fa-calendar-alt"></i></button>
			</div>
		</div>
	</div>	
</template>

<script>

import moment from 'moment';

export default {
	props: ['label','placeholder', 'element_class', 'format', 'date'],
	data() {
		return {
			internal_date: this.date,
			random: Math.random().toString(36).substring(7),
		}
	},

	mounted() {
		let config = {
			format: 'yyyy-mm-dd',
			todayHighlight: true,
		}
		$('#' + this.id).datepicker(config).on('changeDate', (event) => {
			let format_date = moment(event.date).format('YYYY-MM-DD');
			this.internal_date = format_date;
			this.$emit('update',this.internal_date);
		})
	},

	computed: {
		id() {
			return this.label.replace(/[\W_]+/g,"-") + this.random;
		}
	},

	methods: {
		open() {
			$('#' + this.id).datepicker('show');
		}
	},

	watch: {
		date() {
			this.internal_date = this.date;
		}
	}
	
}
</script>

